import { ImageEdit as e, ImageList as t, getDefaultImageBlock as n, getDefaultTwoImagesBlock as r, messages as i } from "@modules/image-editor-ui-components";
import { defineAsyncComponent as a } from "vue";
import { ROUTES as o, getI18n as s } from "@editor/ui-utils";
export * from "@modules/image-editor-ui-components";
//#region src/routes.ts
var c = [{
	path: `/${o.images.path}`,
	meta: { i18RouteTitleKey: o.images.path },
	children: [
		{
			path: "",
			name: "image_list",
			component: t,
			meta: { requiredRight: "images:navigate" }
		},
		{
			path: "new",
			name: "image_new",
			component: e,
			props: () => ({
				title: s().t("router.createImage"),
				backRoute: "/images"
			}),
			meta: { requiredRight: "images:navigate" }
		},
		{
			path: ":id",
			name: "image_detail",
			component: e,
			props: (e) => ({
				title: s().t("router.editImage"),
				id: e.params.id,
				backRoute: "/images"
			}),
			meta: { requiredRight: "images:navigate" }
		}
	]
}], l = a(() => import("./image-article-content-block-DpgQpimg.js")), u = a(() => import("./two-images-article-content-block-CcnlwtyL.js")), d = {
	messages: i,
	routes: c,
	contentBlocks: [{
		type: "IMAGE",
		label: "images.contentBlockLabel",
		icon: "image",
		component: l,
		defaultValue: n()
	}, {
		type: "TWO_IMAGES",
		label: "images.twoImagesContentBlockLabel",
		icon: "columns",
		component: u,
		defaultValue: r()
	}]
};
//#endregion
export { l as ImageContentBlock, u as TwoImagesContentBlock, d as imageModule };

//# sourceMappingURL=index.es.js.map